import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SpinnerComponent {
  @Input() diameter = 40;
  @Input() strokeWidth = 4;
}
